const logger = require('@tencent/intl-log/src');

// 可在此覆盖配置
// const config = {};
// config.logLevel = 'info';
// logger.setConf({});

module.exports = logger;
